import React from 'react';
import Ticket from '../ticket5.png';
import Ecran from '../ecran6.png';

function TicketFeature({ isMobile, t }) {
  return (
    <section
      style={{
        marginTop: 400,
        marginBottom: 40,
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          width: '100%',
          padding: isMobile ? '0 20px' : '0 40px',
          color: '#f9fafb'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              justifyContent: 'start',
              borderRadius: 18,
              padding: 18,
              backdropFilter: 'blur(10px)',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 50,
              alignItems: 'center'
            }}
          >
            {/* --- ZONE IMAGE AVEC BADGE IA --- */}
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
              <img 
                src={Ticket}
                alt="Ticket de caisse"
                style={{
                  width: isMobile ? '200px' : '310px',
                  height: 'auto',
                  borderRadius: 20,
                  boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                  transform: isMobile ? 'none' : 'rotate(-3deg)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              />
              {/* Petit indicateur flottant sur l'image */}
              <div style={{
                position: 'absolute',
                top: -25,
                right: isMobile ? 0 : -20,
                backgroundColor: '#6366f1',
                padding: '6px 30px',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: 'bold',
                boxShadow: '0 4px 12px rgba(99, 102, 241, 0.5)',
                display: 'flex',
                alignItems: 'center',
                gap: 5
              }}>
                ✨ AI SCANNING
              </div>
            </div>

            <div style={{ flex: 1, maxWidth: 400, textAlign: isMobile ? 'center' : 'left' }}>

              <h3
                style={{
                  margin: '0 0 12px 0',
                  fontSize: isMobile ? '1.8rem' : '2.3rem',
                  fontFamily: 'Poppins-Medium',
                  lineHeight: 1.2,
                  textAlign: 'center',
                }}
              >
                {t.ScanTitle}
              </h3>
              
              <p
                style={{
                  margin: 0,
                  fontSize: '1.1rem',
                  opacity: 0.9,
                  lineHeight: 1.6,
                  textAlign: 'center',
                }}
              >
                {t.ScanText}
              </p>
            </div>
            <div>
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
              <img 
                src={Ecran}
                alt="Screen payment"
                style={{
                  width: isMobile ? '200px' : '350px',
                  height: 'auto',
                  borderRadius: 20,
                  boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                  transform: isMobile ? 'none' : 'rotate(+3deg)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              />
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TicketFeature;